"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TempestConsultancy = void 0;
const CardName_1 = require("../../CardName");
const SendDelegateToArea_1 = require("../../deferredActions/SendDelegateToArea");
const Turmoil_1 = require("../../turmoil/Turmoil");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Size_1 = require("../render/Size");
const Tags_1 = require("../Tags");
class TempestConsultancy extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.TEMPEST_CONSULTANCY,
            tags: [Tags_1.Tags.MOON],
            startingMegaCredits: 37,
            initialActionText: 'Place 2 delegates in one party',
            metadata: {
                description: 'You start with 37 M€. As your first action, place 2 delegates in one party.',
                cardNumber: 'MC2',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br;
                    b.megacredits(37).delegates(2);
                    b.corpBox('effect', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.effect('When your delegate becomes the chairman, increase your TR 1 step.', (eb) => {
                            eb.chairman().startEffect.tr(1, Size_1.Size.SMALL);
                        });
                        ce.vSpace(Size_1.Size.SMALL);
                        ce.action('Place 1 delegate in any party for every 5 moon tags you have [max 3.]', (eb) => {
                            eb.empty().startAction.delegates(1).slash(Size_1.Size.LARGE).text('5').nbsp().moon(1).nbsp().asterix();
                        });
                    });
                }),
            },
        });
    }
    play() {
        return undefined;
    }
    initialAction(player) {
        const title = 'Tempest Consultancy first action - Select where to send two delegates';
        player.game.defer(new SendDelegateToArea_1.SendDelegateToArea(player, title, { count: 2, source: 'reserve' }));
        return undefined;
    }
    canAct(player) {
        const delegatesToPlace = Math.min(Math.floor(player.getTagCount(Tags_1.Tags.MOON) / 5), 3);
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        return player.getTagCount(Tags_1.Tags.MOON) >= 5 && turmoil.getDelegatesInReserve(player.id) >= delegatesToPlace;
    }
    action(player) {
        let count = Math.floor(player.getTagCount(Tags_1.Tags.MOON) / 5);
        count = Math.min(count, 3);
        player.game.defer(new SendDelegateToArea_1.SendDelegateToArea(player, `Select a party to send ${count} delegate(s) to`, { count: count, source: 'reserve' }));
        return undefined;
    }
    ;
}
exports.TempestConsultancy = TempestConsultancy;
//# sourceMappingURL=TempestConsultancy.js.map